<template>
  <div id="legalacts" class="legalacts" v-loading.body="loading">
    <el-row style="height:100%">
      <el-col :span="24" style="height:100%;">
        <div style="padding:5px;">
          <el-input placeholder="Поиск..." v-model="search" @change="changeSearchValue" style="width:50%;">
          </el-input>
          <el-button style="float:right;height:36px;" type="primary" icon="plus" @click="addLegalAct">
            Добавить НПА
          </el-button>
        </div>
        <div style="height:100%;padding:5px;">
          <el-table
            ref="legalActsData"
            :data="legalActs"
            border
            highlight-current-row
            v-bind:height="resultsTableHeight"
            @current-change="handleLegalActSelect"
            style="width: 100%; height: 100%;">
            <el-table-column
              property="label"
              label="НПА"
              sortable
              class="grid-text-overflow"
              >
              <template slot-scope="scope">
                 <el-tooltip class="item" effect="dark" :content="scope.row.label" placement="top">
                   <span class="grid-text-overflow">{{ scope.row.label }}</span>
                 </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column
              label="Дата начала действия"
              property="dateStarted"
              sortable
              class="grid-text-overflow"
              width="130">
              <template slot-scope="scope">
                <el-icon name="time"></el-icon>
                <el-tooltip class="item" effect="dark" :content="formatDate(scope.row.dateStarted)" placement="top">
                  <span class="grid-text-overflow" style="margin-left:10px;">{{ formatDate(scope.row.dateStarted) }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column
              label="Дата последней редакции"
              property="dateEdited"
              sortable
              class="grid-text-overflow"
              width="150">
              <template slot-scope="scope">
                <el-icon name="time"></el-icon>
                <el-tooltip class="item" effect="dark" :content="formatDate(scope.row.dateEdited)" placement="top">
                  <span class="grid-text-overflow" style="margin-left:10px;">{{ formatDate(scope.row.dateEdited) }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column
              label="Операции"
              width="115"
              class="grid-text-overflow">
              <template slot-scope="scope">
                <el-button
                  size="small"
                  icon="edit"
                  @click="editLegalAct(scope.$index, scope.row)"></el-button>
                <el-button
                  size="small"
                  type="danger"
                  icon="delete"
                  @click="deleteLegalAct(scope.$index, scope.row)"></el-button>
              </template>
            </el-table-column>
          </el-table>
          </el-table>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import config from '../../appsettings.js'
  import layout from '../../api/helpers/layout'
  import grid from '../../api/helpers/grid'

  export default {
    name: 'legalacts',
    data() {
      return {
        loading: false,
        search: '',
        legalActs: [ {uid: '1', label: 'Нормативно-правовой акт №1', dateStarted: new Date(), dateEdited: new Date()}],
        resultsHeight: null,
        selectedLegalAct: null
      }
    },
    computed: {
      resultsTableHeight: function() {
        if(!this.resultsHeight) {
          let height = layout.getParentClientHeight();
          if(height)
            return height - 77;
        }
        return this.resultsHeight - 47;
      }
    },
    methods: {
      handleLegalActSelect(value) {
        this.selectedLegalAct = value;
      },
      addLegalAct() {
        this.$router.push(config.LEGAL_ACT_URL + '0');
      },
      editLegalAct(index, row) {
        this.selectedLegalAct = row;
        this.$router.push(config.LEGAL_ACT_URL + this.selectedLegalAct.uid);
      },
      deleteLegalAct(index, row) {
        this.$confirm('Вы действительно хотите удалить запись', 'Предупреждение', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Отмена',
          type: 'warning'
        }).then(() => {
          let self = this;
          let prefix = config.API_PREFIX;
          this.$gf.getOptions().then(options => {
            options.params = { };
            let uid = val.uid
            //self.$http.delete(`${prefix}legalacts/${uid}`, options).then(response => {
            //this.fetchData(this.search);
            }).catch(data => {
              this.loading = false;
              self.$gf.checkError(data)
            });
        }).catch(() => {

        });
      },
      changeSearchValue(value) {
        this.fetchData(value)
      },
      fetchData(value) {
        this.loading = true;
        let self = this;
        let prefix = config.API_PREFIX;
        this.$gf.getOptions().then(options => {
          options.params = {
          };
          ///LEGAL ACTS
          /*let get = value ? `${prefix}legalacts/?search=${value}` : `${prefix}legalacts/?search=`;
          self.$http.get(get, options)
            .then(response => {
              self.legalActs = response.data;
              self.loading = false;
              if(self.legalActs && self.legalActs.length)
                self.handleVacancySelect(self.legalActs[0]);
            })
            .catch(data => {
              self.$gf.checkError(data);
              self.loading = false;
            });*/
            self.loading = false;
        }).catch(err => {
          this.$gf.catchOptions();
          this.loading = false;
        });
      },
      resize() {
        let height = layout.getParentClientHeight();
        if(height)
          this.resultsHeight = height - 30;
        else
          this.resultsHeight = null;
      },
      formatDate(d) {
        return grid.formatDate(d);
      },
      formatDateWithHoursAndMinutes(d) {
        return grid.formatDateWithHoursAndMinutes(d);
      }
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.resize);
    },
    created() {
      window.addEventListener('resize', this.resize);
      this.fetchData(this.search);
    }
  }

</script>

<style scoped>
  .legalacts {
  }
  .middle-aligned {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .grid-text-overflow {
    text-overflow: ellipsis;
    white-space: nowrap;
  }
</style>
<style>
  .el-table .cell {
    word-break: normal !important;
  }
  .el-picker-panel {
    min-width: 350px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/registry/legalacts.vue